import React, { useEffect, useState } from "react";
import { apiCall_domain, token } from "../api";
import axios from "axios";
import Spinner from "../Spinner/Spinner";
import { Link } from "react-router-dom";
import Header from "../header";
import { createGlobalStyle } from "styled-components";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import PulseLoader from "react-spinners/PulseLoader";
import Modal from "@mui/material/Modal";
const style = {
  borderRadius: "8px",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  p: 4,
  width: "93%",
  padding: "14px",
};
const ChoseAddress = (props) => {
  const [modal, setModal] = useState(false);

  const [addresses, setAddresses] = useState([]);
  const [country, setCountry] = useState();
  const [loading, setLoading] = useState(true);
  const [phone, setPhone] = useState();
  const [deleteLoader, setDeleteLoader] = useState(false);
  const headers = {
    Authorization: localStorage.getItem("Api_key")
      ? localStorage.getItem("Api_key")
      : token(),
    "content-type": "application/json",
  };
  const getData = () => {
    setLoading(true);
    axios
      .get(`${apiCall_domain}/customer/user/addresses?1`, {
        headers: headers,
      })
      .then((res) => {
        setAddresses(Object.values(res.data.data));
        setLoading(false);
        setModal(false);
      });
  };
  useEffect(() => {
    axios
      .get(`${apiCall_domain}/customer/splash`, {
        headers: headers,
      })
      .then((res) => {
        setCountry(res.data.cities);
        setPhone(res.data.customer_info.phone);
      });
    getData();
  }, []);
  const deleteAddress = (id) => {
    setDeleteLoader(true);
    const Data = {
      id: id,
    };
    axios
      .post(`${apiCall_domain}/customer/user/addresses/delete`, Data, {
        headers: headers,
      })

      .then((res) => {
        getData();
        setDeleteLoader(false);
      });
  };
  const GlobalStyles = createGlobalStyle`body{
      background: #FAFAFA !important;
    }`;
  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <>
          <GlobalStyles />
          <Header showSearchBar={true} title="انتخاب آدرس" backUrl="/profile" />
          <div className="ChoseAddress">
            {addresses.length ? (
              <div className="myAddresses">
                {addresses.map((item, index) => (
                  <div className="innerAddressBox" key={index}>
                    <div className="addressBoxInnertitle">{item.title}</div>
                    <div className="addressBoxInnerMiddle">{item.address}</div>
                    <div className="sectionContacts">
                      <div>
                        <span>شماره تماس : </span>
                        <span>{phone}</span>
                      </div>
                      <div className="locationAddress">
                        <span
                          className="purple deleteAddress"
                          onClick={() => setModal(true)}
                        >
                          <i className="icon-times" />
                        </span>
                        <Modal
                          open={modal}
                          aria-labelledby="modal-modal-title"
                          aria-describedby="modal-modal-description"
                        >
                          <Box sx={style}>
                            <Typography
                              id="modal-modal-title"
                              variant="h6"
                              component="h2"
                            >
                              حذف آدرس
                            </Typography>
                            <Typography
                              id="modal-modal-description"
                              sx={{ mt: 2 }}
                            >
                              آیا از حذف آدرس مطمئن هستید؟
                            </Typography>
                            <Typography
                              id="modal-modal-description"
                              sx={{ mt: 3 }}
                            >
                              <button
                                className="btn btn--addres"
                                onClick={() => deleteAddress(item.id)}
                              >
                                {deleteLoader ? (
                                  <PulseLoader color="#fff" size={12} />
                                ) : (
                                  "بله"
                                )}
                              </button>
                              <button
                                className="btn btn--delete"
                                onClick={() => setModal(false)}
                              >
                                بازگشت
                              </button>
                            </Typography>
                          </Box>
                        </Modal>
                        <Link
                          to={`/profile/editAddress/${item.id}`}
                          className="editAddress "
                        >
                          <i className="icon-pen purple" />
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="emptyAddress">هیچ آدرسی ثبت نشده است</div>
            )}
            <div className="addNewAddressButton">
              <Link to="/profile/addAddress" className="addressAddBtn">
                <button className="btn">افزودن آدرس</button>
              </Link>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ChoseAddress;
